import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { PopularRoutes } from "./components/PopularRoutes";
import { IntercityDrops } from "./components/IntercityDrops";
import { Fares } from "./components/Fares";
import { Fleet } from "./components/Fleet";
import { BookingForm } from "./components/BookingForm";
import { Testimonials } from "./components/Testimonials";
import { Contact } from "./components/Contact";
import { FAQ } from "./components/FAQ";
import { Footer } from "./components/Footer";
import { SeoContent } from "./components/SeoContent";
import { FeedbackSection } from "./components/FeedbackSection";
import { AdminDashboard } from "./components/AdminDashboard";
import { AdminLogin } from "./components/AdminLogin";
import { AuthCallback } from "./components/AuthCallback";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { DriverExpenseEntry } from "./components/DriverExpenseEntry";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import RoutePage from "./components/RoutePage";
import AreaPage from "./components/AreaPage";
import { routePages, areaPages } from "./data/seoPages";
import { ScrollToHash } from "./components/ScrollToHash";
import ReviewRedirect from "./components/ReviewRedirect";

const HomePage = () => {
  return (
    <>
      <Header />
      <Hero />
      <Services />
      <PopularRoutes />
      <IntercityDrops />
      <Fares />
      <Fleet />
      <BookingForm />
      <Testimonials />
      <Contact />
      <FAQ />
      <SeoContent />
      <Footer />
    </>
  );
};

const FeedbackPage = () => {
  return (
    <>
      <Header />
      <FeedbackSection />
      <Footer />
    </>
  );
};

const AdminBookingsPage = ({ user }) => {
  return (
    <>
      <AdminDashboard user={user} />
    </>
  );
};

// Router wrapper to handle auth callback
function AppRouter() {
  const location = useLocation();
  
  // Check for session_id in URL fragment (auth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <ScrollToHash />
      <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/feedback" element={<FeedbackPage />} />
      <Route path="/review" element={<ReviewRedirect />} />
      {routePages.map((p) => (
        <Route key={p.slug} path={`/${p.slug}`} element={<RoutePage page={p} />} />
      ))}
      {areaPages.map((p) => (
        <Route key={p.slug} path={`/${p.slug}`} element={<AreaPage page={p} />} />
      ))}
      <Route path="/driver/expenses" element={<DriverExpenseEntry />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route 
        path="/admin/bookings" 
        element={
          <ProtectedRoute>
            <AdminBookingsPage />
          </ProtectedRoute>
        } 
      />
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
